import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NewSideBarAdmin } from '../../NewSideBarAdmin';
import GetGommercialById from '../../../Services/Admin/GetCommercialById';
import AfficheArticlesCCInfo from '../../../Services/Magasin/AfficheArticlesCCInfo';
import { CommercialInfo } from '../../../Modeles/Commercial';
import { ArticleInfo } from '../../../Modeles/ArticleModel';
import profil from "../IMG/defaultProfil.png";
import "./CommercialInformation.css";

export interface CommandeType {
  Commercial: CommercialInfo[];
  messageErrosCommercial: string;
}

export interface ArticleType {
  Article: ArticleInfo[];
  messageErrosArticle: string;
}

export default function CommercialInformation() {
  const { id, idMag } = useParams();
  const [loading, setLoading] = useState(true);

  const [stateCommercial, setstateCommercial] = useState<CommandeType>({
    Commercial: [] as CommercialInfo[],
    messageErrosCommercial: "Aucun commercial",
  });

  const [stateArticle, setstateArticle] = useState<ArticleType>({
    Article: [] as ArticleInfo[],
    messageErrosArticle: "Aucun article",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const commercialRes = await GetGommercialById(id, idMag).GetCommercial();
        setstateCommercial(prev => ({ ...prev, Commercial: commercialRes.data }));
      } catch (error) {
        console.error("Error fetching commercial data:", error);
      }

      try {
        const articleRes = await AfficheArticlesCCInfo(id).getArticle();
        setstateArticle(prev => ({ ...prev, Article: articleRes.data }));
      } catch (error) {
        console.error("Error fetching article data:", error);
      }

      setLoading(false);
    };

    fetchData();
  }, [id, idMag]);

  const { Commercial } = stateCommercial;

  return (
    <div className="cpi-wrapper">
      <NewSideBarAdmin />

      {loading ? (
        <div className="cpi-loading">
          <span className="cpi-spinner" />
          <span className="cpi-loading-text">Chargement…</span>
        </div>
      ) : (
        <div className="cpi-main">
          <header className="cpi-page-header">
            <button
              onClick={() => window.history.back()}
              className="cpi-back-btn"
              aria-label="Retour"
            >
              <i className="bi bi-arrow-left" />
            </button>
            <div>
              <span className="cpi-eyebrow">Personnel</span>
              <h1 className="cpi-page-title">Profil du personnel</h1>
              <p className="cpi-page-subtitle">Gérez les informations de ce membre du personnel</p>
            </div>
          </header>

          <div className="cpi-content">
            <InformationsGénerale commercial={Commercial} />
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Informations générales — hero + coordonnées
───────────────────────────────────────────── */
const InformationsGénerale: React.FC<{ commercial: CommercialInfo[] }> = ({ commercial }) => {
  const [showPassword, setShowPassword] = useState(false);

  if (commercial.length === 0) {
    return (
      <section className="cpi-card cpi-empty-wrap cpi-fade-in">
        <div className="cpi-empty-state">
          <i className="bi bi-inbox" />
          <p>Aucun commercial trouvé</p>
        </div>
      </section>
    );
  }

  return (
    <>
      {commercial.map((item, index) => (
        <div key={index} className="cpi-fade-in">
          {/* ── Hero / identity panel ── */}
          <section className="cpi-hero">
            <span className="cpi-hero-glow" aria-hidden="true" />

            <div className="cpi-hero-main">
              <img src={profil} alt="Profil" className="cpi-avatar" />
              <div className="cpi-hero-id">
                <span className="cpi-role-tag">
                  <i className="bi bi-person-badge" /> Commercial
                </span>
                <h2>{item.Nom} {item.Prenom}</h2>
                <span className="cpi-status-pill">
                  <i className="bi bi-circle-fill" /> Actif
                </span>
              </div>
            </div>

            <div className="cpi-hero-stats">
              <div className="cpi-stat">
                <span className="cpi-stat-label">
                  <i className="bi bi-wallet2" /> Solde
                </span>
                <span className="cpi-stat-value">
                  {item.Credit || 0} <small>MAD</small>
                </span>
              </div>
              <div className="cpi-stat-divider" />
              <div className="cpi-stat">
                <span className="cpi-stat-label">
                  <i className="bi bi-percent" /> Remise globale
                </span>
                <span className="cpi-stat-value">
                  {item.RemiseGlobal || 0}<small>%</small>
                </span>
              </div>
            </div>
          </section>

          {/* ── Coordonnées ── */}
          <div className="cpi-section-label">Coordonnées</div>
          <section className="cpi-details-grid">
            <div className="cpi-detail-card">
              <div className="cpi-detail-icon">
                <i className="bi bi-envelope-fill" />
              </div>
              <div className="cpi-detail-content">
                <label>Email</label>
                <p>{item.Email}</p>
              </div>
            </div>

            <div className="cpi-detail-card">
              <div className="cpi-detail-icon">
                <i className="bi bi-telephone-fill" />
              </div>
              <div className="cpi-detail-content">
                <label>Téléphone</label>
                <p>{item.Tele}</p>
              </div>
            </div>

            <div className="cpi-detail-card">
              <div className="cpi-detail-icon">
                <i className="bi bi-lock-fill" />
              </div>
              <div className="cpi-detail-content cpi-detail-content-row">
                <div>
                  <label>Mot de passe</label>
                  <p>{showPassword ? item.Password : "••••••••"}</p>
                </div>
                <button
                  className="cpi-eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`} />
                </button>
              </div>
            </div>
          </section>

          {/* ── Danger zone ── */}
          <section className="cpi-danger-zone">
            <div>
              <h4>Zone sensible</h4>
              <p>La suppression de ce compte est définitive et irréversible.</p>
            </div>
            <button className="cpi-btn-danger">
              <i className="bi bi-trash-fill" /> Supprimer le compte
            </button>
          </section>
        </div>
      ))}
    </>
  );
};

/* ─────────────────────────────────────────────
   Catalogue produits (not rendered by default —
   kept available for future use on this page)
───────────────────────────────────────────── */
const SesProduits: React.FC<{ articles: ArticleInfo[] }> = ({ articles }) => {
  return (
    <section className="cpi-card cpi-fade-in">
      <div className="cpi-card-header">
        <div>
          <h3>Catalogue produits</h3>
          <p className="cpi-card-subtitle">Liste des articles du commercial</p>
        </div>
      </div>

      <div className="cpi-table-wrap">
        {articles && articles.length > 0 ? (
          <table className="cpi-table">
            <thead>
              <tr>
                <th>Article</th>
                <th>Quantité</th>
                <th>Prix</th>
              </tr>
            </thead>
            <tbody>
              {articles.map((art, index) => (
                <tr key={index}>
                  <td>
                    <div className="cpi-product-cell">
                      <img src={profil} alt="Produit" className="cpi-product-img" />
                      <div>
                        <h5>{art.Designation}</h5>
                        <span className="cpi-product-ref">{art.RefArticle}</span>
                      </div>
                    </div>
                  </td>
                  <td><span className="cpi-qty-badge">{art.stock || 0}</span></td>
                  <td><strong className="cpi-price">{art.PrixVenteArticleTTC} MAD</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="cpi-empty-state">
            <i className="bi bi-box-seam" />
            <p>Aucun article trouvé</p>
          </div>
        )}
      </div>
    </section>
  );
};

/* ─────────────────────────────────────────────
   Commandes associées (not rendered by default —
   kept available for future use on this page)
───────────────────────────────────────────── */
const CommandesAssociées: React.FC = () => {
  return (
    <section className="cpi-card cpi-fade-in">
      <div className="cpi-card-header">
        <div>
          <h3>Commandes associées</h3>
          <p className="cpi-card-subtitle">Historique des commandes</p>
        </div>
      </div>
      <div className="cpi-table-wrap">
        <div className="cpi-empty-state">
          <i className="bi bi-receipt" />
          <p>Aucune commande associée pour le moment</p>
        </div>
      </div>
    </section>
  );
};